import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';

@Component({
  selector: 'app-product-setting',
  templateUrl: './product-setting.component.html',
  styleUrls: ['./product-setting.component.css']
})
export class ProductSettingComponent implements OnInit {

  constructor(
    public loginService: LoginService,
    public authService: AuthService,
    public alertService: AlertService
  ) { }
  status: boolean = false;
  submitted: boolean = true;
  paymentEntryVerbiage: any;
  token = this.authService.getToken()
  isLoading: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  // disclaimer = "Freedom Mortgage charges an upfront fee to cover certain costs incurred with the processing of your loan application. This may include the cost of ordering the appraisal or a rate lock fee.By clicking Yes below you acknowledge that you received a copy of the Loan Estimate and previously provided your intent to proceed with the transaction. You also authorize Freedom Mortgage to order an appraisal and/or lock your interest rate and charge the amount entered above to the credit card or debit card number you provided. The billing company that manages the payment process on behalf of Freedom Mortgage is “Automated Fee Services. Therefore, the name Automated Fee Services will appear on your credit card/debit card statement along with the customer service contact information for the company.Your statement will display 'Mortgage Related Fees' as the purpose for the transaction.You further understand that: 1. This fee may be non-refundable except where required under state law 2. You are responsible to pay for the fee regardless of the value of your property as determined by the appraiser 3. Payment of the fee does not guarantee approval for any particular loan product and your loan must undergo a full underwriting review."
  ngOnInit(): void {
    this.getData()
  }

  getData() {
    this.isLoading = true;
    this.loginService.details(this.token).subscribe((res) => {
      console.log("product setting",res);
      this.paymentEntryVerbiage = res['paymentEntryVerbiage'];
      this.productSettingForm.disable();
      this.productSettingForm = new FormGroup(
        {
          requestExpirationMinutes: new FormControl(res['numberOfDaysForExpiry'],[Validators.required,this.validateNumberRange]),
          paymentEntryVerbiage: new FormControl(res['paymentEntryVerbiage']),
        })
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      console.log(err);
    })
  }

  productSettingForm: FormGroup = new FormGroup(
    {
      requestExpirationMinutes: new FormControl(3,[Validators.required,this.validateNumberRange]),
      paymentEntryVerbiage: new FormControl('', [Validators.required]),
    })

  onSubmit() {
    if (!this.status) {
      this.productSettingForm.enable();
      this.status = true;
      return
    }
    else {
      this.submitted = true;
      this.isLoading = true;
      if (this.productSettingForm.valid) {
        //get csrf token
        this.loginService.csrfToken().subscribe((response: any) => {
          console.log(response);
          console.log(response.csrfToken);
          this.loginService.desClaimer(this.productSettingForm.value, this.token, response.csrfToken).
            subscribe((response) => {
              console.log(response);
              this.productSettingForm.disable();
              this.status = false;
              this.isLoading = false;
              this.alertService.success('Success!! Data Saved SuccessFully.', this.options);
            }, (err) => {
              this.isLoading = false;
              console.log(err);
              this.alertService.error(err.error, this.options);
              this.alertService.error(err.error.errors.Messages[0], this.options);
            })
        })
      }
      else {
        this.isLoading = false;
        console.log('please enter valid data');
        // this.alertService.error('Error!! Please enter valid data.', this.options);
      }
    }
  }

  reset() {
    this.productSettingForm.disable();
    this.status = false;
  }

  get forms() {
    return this.productSettingForm.controls;
  }

  //
  validateNumberRange(control) {
    const value = control.value;
    if (value === null) {
      return null; // No validation for null values
    }
    if (value < 3 || value > 90) {
      return { invalidNumber: true };
    }
    return null;
  }
}
